/*
Created by Andy Bean on Tue Nov 22 2016

Copyright (c) 2016 British Geological Survey. All rights reserved.
*/
require([
	//ESRI features
	"esri/views/MapView",
	"esri/Map",
	"esri/WebMap",
	"esri/widgets/Compass",
	"esri/Graphic",
	"esri/layers/GraphicsLayer",
	"esri/layers/MapImageLayer",
	"esri/symbols/SimpleMarkerSymbol",
	"esri/symbols/SimpleLineSymbol",
	"esri/symbols/SimpleFillSymbol",
	"esri/geometry/Point",
	"esri/geometry/Extent",
	"esri/core/watchUtils",
	"esri/geometry/SpatialReference",
	"esri/tasks/GeometryService",
	"esri/geometry/geometryEngine",
	"esri/tasks/support/LinearUnit",
	"esri/tasks/support/LengthsParameters", "esri/geometry/support/webMercatorUtils",
	"esri/widgets/Legend",
	      "esri/tasks/IdentifyTask",
      "esri/tasks/support/IdentifyParameters",

	//Custom features
	"application/MyLegend",
	"application/CustomCompass",
	"application/CrossSectionBuilder",
	"application/BoreholeBuilder",
	"application/SliceBuilder",

	//Dojo features
	"dojo/on",
	"dojo/request/xhr",
	"dojo/dom",
	"dojo/_base/array",
	"dojo/domReady!"
], function (
		MapView, Map, WebMap, Compass, Graphic, GraphicsLayer, MapImageLayer, SimpleMarkerSymbol, SimpleLineSymbol, SimpleFillSymbol, Point, Extent, watchUtils, SpatialReference, GeometryService, geometryEngine, LinearUnit, LengthsParameters, webMercatorUtils, Legend, IdentifyTask, IdentifyParameters, MyLegend, CustomCompass, CrossSectionBuilder, BoreholeBuilder, SliceBuilder, on, xhr, dom, arrayUtils) {

	//Load configuration JSON
	xhr("config.json", {
		url: "config.json",
		handleAs: "json",
		preventCache: true,
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json"
		}
	}).then(function (data) {
		console.log("Config Loaded");
		setupApp(data);
	}, function (err) {
		document.getElementById("mapView").innerHTML = "Failed to load configuration file";
		console.log("Fail");
		console.log(err);
		return;
	});

	function setupApp(config) {
		window.config = config;
		//Setup base map
		var map = new Map({
			basemap: config.basemap
		});
		config.map = map;

		//Setup map view
		//TODO: Set initial map view based on ArcGIS server data extent
		var view = new MapView({
			container: "mapView",
			map: map,
			zoom: config.initialZoom,
			center: config.initialCenter
		});
		config.view = view;

		//Add Geology layers from ArcGis Server
		var geologyLayer = new MapImageLayer({
			url: config.layerServer.url,
			sublayers: [

				{
					id: config.layerServer.layers.l_surfaceGeology,
					visible: true,
					opacity: 0.5
				},
							{
					id: config.layerServer.layers.l_boreholes,
					visible: true,
					opacity: 0
			},
			{
					id: config.layerServer.layers.l_sGUBoreholes,
					visible: true,
					opacity: 0
			},
				{
					id: config.layerServer.layers.l_wells,
					visible: true,
					opacity: 0
			},
							{
					id: config.layerServer.layers.l_eWCrossSection,
					visible: true,
					opacity: 0
			},
		{
					id: config.layerServer.layers.l_nSCrossSection,
					visible: true,
					opacity: 0
			},
				{
					id: config.layerServer.layers.l_3DModelExtent,
					visible: false,
					opacity: 1
			},

		]
		});
		config.map.add(geologyLayer);

		  var legend = new MyLegend({
            view: view,
            layerInfos: [{
              layer: geologyLayer,
              title: "Legend"
            }],
			layer: geologyLayer,
			config: config
          });
		console.log(legend);

          // Adds an instance of Legend widget to the
          // bottom right of the view.
          view.ui.add(legend, "bottom-right");


		var STATE = {
			INITIAL: {value: 0, name:"Default State"},
			BOREHOLE: {value: 1, name:"Borehole View"},
			CROSS: {value: 2, name:"Cross-section View"},
			SLICE: {value: 3, name:"Horizontal section"}
		};

		var state = STATE.INITIAL;
		var defaultToggle = dom.byId("defaultState");
		view.ui.add(defaultToggle, "bottom-left");

		// zooms the view to the full extent of all data
		geologyLayer.then(function () {
			view.goTo(geologyLayer.fullExtent);
			on(dom.byId("crosssectionBuilder__toggle"), "change", function (event) {				geologyLayer.findSublayerById(config.layerServer.layers.l_3DModelExtent).visible = event.target.checked;
				state = STATE.CROSS;
			});

			on(dom.byId("boreholeBuilder__toggle"), "change", function (event) {
				geologyLayer.findSublayerById(config.layerServer.layers.l_3DModelExtent).visible = event.target.checked;
				state = STATE.BOREHOLE;
			});

			on(dom.byId("sliceBuilder__toggle"), "change", function (event) {
				geologyLayer.findSublayerById(config.layerServer.layers.l_3DModelExtent).visible = event.target.checked;
				state = STATE.SLICE;
			});

			on(dom.byId("defaultState__toggle"), "change", function () {
				geologyLayer.findSublayerById(config.layerServer.layers.l_3DModelExtent).visible = false;
				state = STATE.INITIAL;
			});

		});


		//Add compass only when map is rotated
		new CustomCompass(view);



		//on(view, "click", crossSectionBuild.addPoint(config));

		//Setup borehole builder
		var boreholeBuild = new BoreholeBuilder(config, map, view);
		boreholeBuild.buildBoreholeUI();
		boreholeBuild.setupMap();

				//Setup cross-section builder
		var crossSectionBuild = new CrossSectionBuilder(config, map, view);
		crossSectionBuild.buildCrossSectionUI();
		crossSectionBuild.setupMap();


				//Setup slice builder
		var sliceBuild = new SliceBuilder(config, map, view);
		sliceBuild.buildSliceUI();

		
		var params, identifyTask;
		
		identifyTask = new IdentifyTask(config.layerServer.url);
		
		        params = new IdentifyParameters();
        params.tolerance = 3;
        params.layerIds = [0, 1, 2];
        params.layerOption = "top";
        params.width = view.width;
        params.height = view.height;
		console.log(params);
		
		//on(view, "click", boreholeBuild.addPoint(config));
		on(view, "click", handleMapClick);

		      function executeIdentifyTask(event) {
        // Set the geometry to the location of the view click
				  console.log(params);
        params.geometry = event.mapPoint;
        params.mapExtent = view.extent;
        dom.byId("mapView").style.cursor = "wait";

        // This function returns a promise that resolves to an array of features
        // A custom popupTemplate is set for each feature based on the layer it
        // originates from
        identifyTask.execute(params).then(function(response) {

          var results = response.results;
console.log(results);
          return arrayUtils.map(results, function(result) {
			  console.log(results);
            var feature = result.feature;
            var layerName = result.layerName;

            feature.attributes.layerName = layerName;
            if (layerName === 'Boreholes') {
              feature.popupTemplate = { // autocasts as new PopupTemplate()
                title: "Borehole: {HOLEID}",
                content: "<b>StartZ:</b> {START_Z}<br/><b>EndZ:</b> {END_Z}"
              };
            }
            else if (layerName === 'SGU Boreholes') {
              feature.popupTemplate = { // autocasts as new PopupTemplate()
                title: "SGU Borehole: {HOLEID}",
                content: "<b>StartZ:</b> {START_Z}<br/><b>EndZ:</b> {END_Z}"
              };
            }
            else if (layerName === 'Wells') {
              feature.popupTemplate = { // autocasts as new PopupTemplate()
                title: "Well: {HOLEID}",
                content: "<b>StartZ:</b> {START_Z}<br/><b>EndZ:</b> {END_Z}"
              };
            }
            return feature;
          });
        }).then(showPopup); // Send the array of features to showPopup()

        // Shows the results of the Identify in a popup once the promise is resolved
        function showPopup(response) {
          if (response.length > 0) {
            view.popup.open({
              features: response,
              location: event.mapPoint
            });
          }
          dom.byId("mapView").style.cursor = "auto";
        }
      }

	  function checkModel(event) {
		  
		var params = new IdentifyParameters();
        params.tolerance = 3;
        params.layerIds = [5];
        params.layerOption = "top";
        params.width = view.width;
        params.height = view.height;

        // Set the geometry to the location of the view click		
        params.geometry = event.mapPoint;
        params.mapExtent = view.extent;
        dom.byId("mapView").style.cursor = "wait";

		return new Promise(function(resolve, reject) {
        // This function returns a promise that resolves to an array of features
        // A custom popupTemplate is set for each feature based on the layer it
        // originates from
        identifyTask.execute(params).then(function(response) {
			console.log("Hello");
			dom.byId("mapView").style.cursor = "auto";
			console.log(response.results);
			if(response.results.length > 0) {
				console.log(response.results[0]);
				resolve(response.results[0].value)
			}
			else {
				reject();
			}
		})
		});
	  }
	  
		function handleMapClick(event) {
			if(event.screenPoint.x < 60 && (view.height-event.screenPoint.y) <150) {
				//Probably trying to click the state buttons
				//rather than placing boreholes etc
				return;
			}

			if(state == STATE.INITIAL)
			{
				executeIdentifyTask(event);
				return;
			}
			if(state == STATE.BOREHOLE)
			{
				checkModel(event).then(function(model) { 
					console.log("Resolved: " + model); 
					boreholeBuild.addPoint(config,model,event);})
					.catch(function(error) {
						console.log("Not inside a model");
					});
				
			}
			if(state == STATE.CROSS)
			{
				checkModel(event).then(function(model) { 
					console.log("Resolved: " + model); 
					crossSectionBuild.addPoint(config,model,event);})
					.catch(function(error) {
						console.log("Not inside a model");
					});
			}
			if(state == STATE.SLICE)
			{
				return;
			}
		}
	}
});
